import type { StaticImageData } from "next/image";
import { Role } from "@rosette/ts/src/business/role/Role.js";
import standardIcon from "@rosette/assets/src/roles/standard.png";
import goldIcon from "@rosette/assets/src/roles/gold.png";
import memburGreenIcon from "@rosette/assets/src/roles/membur_green.png";
import diamondIcon from "@rosette/assets/src/roles/diamond.png";
import teamIcon from "@rosette/assets/src/roles/team.png";
import adminIcon from "@rosette/assets/src/roles/admin.png";


export function getRoleIcon(role: Role): StaticImageData {
    if (role === Role.STANDARD)
        return standardIcon;
    if (role === Role.GOLD)
        return goldIcon;
    if (role === Role.MEMBUR)
        return diamondIcon;
    if (role === Role.TEAM)
        return teamIcon;
    if (role === Role.ADMIN)
        return adminIcon;

    throw new Error("Unknown role type, " + role.getID());
}


export function getGreenMemburIcon(): StaticImageData {
    return memburGreenIcon;
}


// Complete class names, so Tailwind sees them.
export function getRoleTagClasses(role: Role): string {
    if (role === Role.STANDARD)
        return "bg-role-standard text-black";
    if (role === Role.GOLD)
        return "bg-role-gold text-white";
    if (role === Role.MEMBUR)
        return "bg-role-membur text-white";
    if (role === Role.TEAM)
        return "bg-role-team text-white";
    if (role === Role.ADMIN)
        return "bg-role-admin text-white";

    throw new Error("Unknown role type, " + role.getID());
}


/** The role's colour as a CSS value, for style props. */
export function getRoleColour(role: Role): string {
    if (role === Role.STANDARD)
        return "var(--color-role-standard)";
    if (role === Role.GOLD)
        return "var(--color-role-gold)";
    if (role === Role.MEMBUR)
        return "var(--color-role-membur)";
    if (role === Role.TEAM)
        return "var(--color-role-team)";
    if (role === Role.ADMIN)
        return "var(--color-role-admin)";

    throw new Error("Unknown role type, " + role.getID());
}


export function getGreenMemburColour(): string {
    return "var(--color-role-membur-green)";
}
